import { render, staticRenderFns } from "./SchematicTab.vue?vue&type=template&id=1d2f4af7&scoped=true&"
import script from "./SchematicTab.vue?vue&type=script&lang=ts&"
export * from "./SchematicTab.vue?vue&type=script&lang=ts&"
import style0 from "./SchematicTab.vue?vue&type=style&index=0&id=1d2f4af7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2f4af7",
  null
  
)

export default component.exports